export const categories = [
  { slug: 'wanghong-tafang', name: '网红塌房', icon: 'ri-alert-line', description: '网红博主塌房事件第一手报道' },
  { slug: 'zhubo-bagua', name: '主播八卦', icon: 'ri-live-line', description: '直播圈内幕与主播八卦爆料' },
  { slug: 'mingxing-heiliao', name: '明星黑料', icon: 'ri-star-line', description: '娱乐圈明星黑料深度挖掘' },
  { slug: 'shehui-redian', name: '社会热点', icon: 'ri-fire-line', description: '社会热点事件追踪报道' },
  { slug: 'dujia-baoliao', name: '独家爆料', icon: 'ri-spy-line', description: '独家内幕消息首发曝光' },
  { slug: 'chigua-shipin', name: '吃瓜视频', icon: 'ri-video-line', description: '吃瓜视频合集在线观看' },
];

export const articles = [
  {
    id: 1,
    title: '某千万粉丝美食博主被前员工实名举报偷税漏税，金额高达数千万',
    excerpt: '曾以"接地气"形象走红的美食博主XXX，近日被多名前员工联合实名举报，涉嫌通过虚假发票、阴阳合同等方式偷逃税款。据悉，涉案金额高达数千万元，税务部门已介入调查。',
    content: `曾以"接地气"形象走红的美食博主XXX，近日被多名前员工联合实名举报，涉嫌通过虚假发票、阴阳合同等方式偷逃税款。

据举报人透露，该博主在2022年至2025年间，通过多家关联公司将个人收入转移至低税率地区，同时利用虚假发票冲抵成本。举报材料中包含了大量内部财务记录和聊天截图，证据链完整。

税务部门相关人士表示已收到举报材料，正在依法核查。若查实，该博主将面临补缴税款、滞纳金及罚款，总金额可能超过其偷逃税款的两倍。

事件曝光后，该博主社交账号已停止更新，多个品牌方紧急解约。粉丝群体出现严重分化，部分铁粉表示"等待真相"，但更多人表达失望与愤怒。

业内人士分析称，近年来网络主播、自媒体博主的税务问题已成为监管重点，此次事件可能引发新一轮行业整治。`,
    category: 'wanghong-tafang',
    tags: ['偷税漏税', '美食博主', '实名举报', '税务调查'],
    views: 283000,
    date: '2026-07-07',
    author: '吃瓜前线',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20news%20scene%20of%20a%20popular%20Chinese%20internet%20celebrity%20being%20exposed%20for%20tax%20evasion%2C%20darkened%20studio%20with%20spotlight%2C%20financial%20documents%20scattered%2C%20investigative%20journalism%20mood%2C%20warm%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20mysterious%20atmosphere%2C%20Chinese%20entertainment%20news%20aesthetic%2C%20deep%20red%20and%20gold%20accents%2C%20professional%20photojournalism%20quality&width=800&height=500&seq=article-hero-01&orientation=landscape',
    featured: true,
    exclusive: true,
    hot: true,
  },
  {
    id: 2,
    title: '知名游戏主播深夜直播中情绪崩溃，自曝被MCN机构压榨三年',
    excerpt: '拥有500万粉丝的知名游戏主播"XX酱"在昨晚直播中突然情绪失控，泣不成声地揭露签约MCN机构对其长达三年的不公平待遇，包括克扣分成、强制加班等。',
    content: `拥有500万粉丝的知名游戏主播"XX酱"在昨晚直播中突然情绪失控，泣不成声地揭露签约MCN机构对其长达三年的不公平待遇。

在直播中，XX酱展示了一份详细的合同和收入流水记录。据其所述，按照合同约定她应获得直播收入的60%分成，但实际到手不到30%。MCN机构以各种名目克扣分成，包括"运营服务费""技术支持费""品牌推广费"等从未在合同中出现的项目。

此外，XX酱还控诉机构强制要求每天直播10小时以上，周末和节假日也不例外。她曾因连续高强度直播导致声带受损入院治疗，却被机构要求"带病上播，不能让粉丝失望"。

事件迅速登上热搜，引发广泛讨论。多位知名主播公开声援，并分享自己被MCN机构压榨的类似经历。业内律师指出，此类"霸王条款"在直播行业较为普遍，主播维权面临取证难、诉讼周期长等困境。

涉事MCN机构在舆论压力下发布声明，称"正在核实相关情况"，但未正面回应指控。`,
    category: 'zhubo-bagua',
    tags: ['游戏主播', 'MCN压榨', '直播行业', '合同纠纷'],
    views: 356000,
    date: '2026-07-06',
    author: '吃瓜前线',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20of%20a%20gaming%20streamer%20in%20emotional%20distress%20during%20a%20late%20night%20live%20stream%2C%20dimly%20lit%20room%20with%20computer%20screens%2C%20streamer%20crying%20silhouette%2C%20dramatic%20warm%20and%20dark%20contrast%2C%20Chinese%20entertainment%20news%20photography%2C%20emotional%20documentary%20style%2C%20professional%20lighting%2C%20storytelling%20visual&width=800&height=500&seq=article-hero-02&orientation=landscape',
    featured: true,
    exclusive: false,
    hot: true,
  },
  {
    id: 3,
    title: '当红演员深夜密会神秘女子，工作室火速发声明否认恋情',
    excerpt: '有媒体拍到某当红男演员深夜与一名神秘女子从高档餐厅一同离开，随后进入同一小区。照片曝光后，工作室连夜发布声明称两人只是朋友聚餐。',
    content: `有媒体拍到某当红男演员深夜与一名神秘女子从高档餐厅一同离开，随后进入同一小区，引发恋情猜测。

据拍摄者描述，当晚该演员与神秘女子在餐厅包间用餐近三小时，离开时两人举止亲密，女方还挽着男方的胳膊。两人随后乘坐同一车辆前往某高档小区，直到次日凌晨女方仍未离开。

照片曝光后迅速登上热搜榜首，粉丝群体反应激烈。该演员工作室连夜发布声明，表示"两人是多年好友，当晚系正常朋友聚餐，不存在恋情关系"，并称将保留追究偷拍者法律责任的权利。

但网友并不买账，有人翻出该演员此前多次被拍到与该女子同框的画面。更有知情人士爆料，两人实则已经交往两年，女方为圈外人，家境优渥。

娱乐评论人分析，该演员正处于事业上升期，团队不希望恋情曝光影响商业价值和粉丝基础。但如今的粉丝对偶像恋爱的接受度已大幅提高，"隐瞒反而容易适得其反"。`,
    category: 'mingxing-heiliao',
    tags: ['演员恋情', '偷拍曝光', '工作室回应', '娱乐圈'],
    views: 512000,
    date: '2026-07-06',
    author: '娱乐探长',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20actor%20leaving%20a%20luxury%20restaurant%20at%20night%20with%20a%20mysterious%20woman%2C%20paparazzi%20photography%20style%2C%20dark%20street%20scene%20with%20warm%20restaurant%20light%20spilling%20out%2C%20dramatic%20shadow%20and%20light%20contrast%2C%20Chinese%20entertainment%20news%20aesthetic%2C%20candid%20documentary%20style%2C%20mysterious%20atmosphere&width=800&height=500&seq=article-hero-03&orientation=landscape',
    featured: false,
    exclusive: true,
    hot: true,
  },
  {
    id: 4,
    title: '知名美妆博主被指虚假宣传，多款推荐产品遭药监局点名',
    excerpt: '拥有800万粉丝的美妆博主近日陷入虚假宣传风波，其大力推荐的数款护肤品被药监局通报存在违规添加、虚假标注等问题。',
    content: `拥有800万粉丝的美妆博主近日陷入虚假宣传风波。国家药监局最新通报中，该博主大力推荐的数款护肤品被点名存在违规添加激素、虚假标注成分等问题。

通报显示，涉事产品中一款号称"纯天然植物萃取"的面霜实则添加了强效激素，长期使用可能导致皮肤依赖、色素沉着等严重问题。另外几款热销精华液则存在成分标注与实际不符的情况，部分宣称的"专利成分"经查并不存在。

该博主此前在直播中多次强调这些产品"亲测有效""自用三年"，并展示所谓的使用前后对比图。但调查发现，对比图存在严重修图痕迹，多个"素人推荐"实为MCN机构安排的水军。

事件发酵后，该博主发布道歉视频，称自己"选品不严谨""被品牌方蒙骗"。但这番说辞未能平息众怒，大量受害消费者要求其承担连带赔偿责任。

中国消费者协会已介入调查，并表示将支持消费者依法维权。法律专家指出，根据《广告法》，广告代言人明知或应知广告虚假仍作推荐的，应当承担连带责任。`,
    category: 'wanghong-tafang',
    tags: ['美妆博主', '虚假宣传', '药监局', '消费者维权'],
    views: 198000,
    date: '2026-07-05',
    author: '质量观察员',
    image: 'https://readdy.ai/api/search-image?query=Beauty%20blogger%20scandal%20scene%2C%20makeup%20products%20on%20a%20table%20with%20warning%20labels%2C%20dramatic%20lighting%20with%20red%20accents%2C%20Chinese%20consumer%20rights%20investigation%20theme%2C%20editorial%20photography%2C%20professional%20studio%20lighting%2C%20suspicious%20atmosphere%2C%20dark%20background%20with%20product%20spotlight&width=800&height=500&seq=article-hero-04&orientation=landscape',
    featured: false,
    exclusive: false,
    hot: false,
  },
  {
    id: 5,
    title: '网红夫妻档被曝婚变，男方疑似转移资产，女方深夜发文暗示',
    excerpt: '以恩爱夫妻人设走红的网红夫妻近日被传婚变，有网友发现男方频繁出入某高档小区，而女方深夜发布意味深长的动态引发猜测。',
    content: `以恩爱夫妻人设走红的网红夫妻近日被传婚变，引发广泛关注。

事情起因是有网友在社交平台爆料，称看到男方多次深夜出入某高档小区，且身边总有不同女性陪伴。网友还附上了模糊的"偶遇"照片，虽然画质不佳但轮廓确实与该男网红相似。

随后，女方深夜在社交平台发布了一句意味深长的话："有些真相，不是不报，时候未到。"配图是一杯已经凉透的咖啡。这条动态在发布后不久即被删除，但已被大量网友截图保存。

更令人震惊的是，有财经博主分析了两人的商业关联，发现男方近期频繁变更名下公司股权，疑似在转移共同财产。两人共同拥有的传媒公司估值过亿，若离婚将面临复杂的财产分割。

截至目前，双方均未正面回应婚变传闻。但两人的联合直播账号已停更半个月，此前发布的合作广告也被品牌方临时撤下。

婚姻律师表示，网红夫妻的婚变往往牵涉复杂的商业利益，建议双方通过法律途径妥善解决。`,
    category: 'wanghong-tafang',
    tags: ['网红夫妻', '婚变', '财产转移', '塌房'],
    views: 445000,
    date: '2026-07-04',
    author: '吃瓜一线',
    image: 'https://readdy.ai/api/search-image?query=A%20dramatic%20scene%20depicting%20internet%20celebrity%20couple%20marriage%20breakdown%2C%20split%20composition%20showing%20two%20sides%2C%20cold%20atmosphere%2C%20luxury%20apartment%20night%20scene%2C%20Chinese%20social%20media%20drama%20aesthetic%2C%20emotional%20distance%20theme%2C%20cinematic%20lighting%2C%20warm%20and%20cold%20color%20contrast&width=800&height=500&seq=article-hero-05&orientation=landscape',
    featured: true,
    exclusive: true,
    hot: true,
  },
  {
    id: 6,
    title: '某教育博主学历造假被扒，清华博士头衔系培训机构购买',
    excerpt: '拥有百万粉丝的教育类博主被网友扒出学历造假，其宣称的清华大学博士学历实为某培训机构颁发的"荣誉证书"，引发舆论哗然。',
    content: `拥有百万粉丝的教育类博主被网友扒出学历造假，其宣称的清华大学博士学历实为某培训机构颁发的"荣誉证书"。

该博主在个人简介中标注"清华博士"，日常短视频中也常以"清华学长"身份分享学习方法、推荐教辅资料，吸引了大量学生和家长的关注与信任。然而，有细心网友发现该博主的博士论文无法在知网检索到。

进一步调查发现，该博主的所谓"清华博士"实际上是某培训机构与海外野鸡大学合办的"研修班"结业证书，根本不具备任何学历效力。而该博主本人在视频中刻意模糊表述，误导粉丝认为是清华大学正规博士学历。

事件曝光后，多名学生家长表示愤怒和失望，称正是因为信任"清华博士"头衔才购买了其推荐的课程和资料，累计花费数千元甚至上万元。

目前该博主已关闭评论功能，删除了个人简介中的学历信息。但有律师指出，如果其利用虚假学历进行了商业变现，可能构成欺诈，消费者有权要求退一赔三。`,
    category: 'shehui-redian',
    tags: ['学历造假', '教育博主', '虚假人设', '消费者欺诈'],
    views: 167000,
    date: '2026-07-04',
    author: '真相调查',
    image: 'https://readdy.ai/api/search-image?query=A%20fake%20diploma%20scandal%20scene%2C%20Chinese%20education%20blogger%20exposed%2C%20certificate%20with%20a%20red%20X%20mark%2C%20dark%20study%20room%20atmosphere%2C%20suspicious%20document%20investigation%20theme%2C%20editorial%20photography%2C%20dramatic%20shadow%20lighting%2C%20academic%20fraud%20visual%2C%20warm%20and%20dark%20contrast&width=800&height=500&seq=article-hero-06&orientation=landscape',
    featured: false,
    exclusive: false,
    hot: false,
  },
  {
    id: 7,
    title: '独家：某头部带货主播选品团队内幕曝光，佣金高达70%依旧翻车',
    excerpt: '本报独家获取某头部带货主播选品团队内部资料，揭示其选品流程存在严重漏洞，高佣金低品质产品频频"上车"，消费者投诉不断。',
    content: `本报独家获取某头部带货主播选品团队内部资料，震撼揭示其选品流程中的严重问题。

根据曝光的内部文档，该主播团队的选品标准第一项不是产品质量，而是"佣金率"。文档中明确标注："优先推荐佣金率50%以上的产品，低于30%不予考虑"。据知情人士透露，部分品类的佣金率甚至高达70%。

这意味着消费者每支付100元购买该主播推荐的商品，其中高达70元进入主播和团队口袋。在如此高昂的销售成本下，品牌方只能压缩产品成本，导致消费者拿到手的商品质量远低于预期。

更令人忧心的是，该团队所谓的"选品试用"环节形同虚设。内部记录显示，部分产品的"试用报告"与实际使用时间严重不符，少数产品甚至在上架前一晚才送到，根本来不及进行任何质量检测。

多位消费者向本报反映，在该主播直播间购买的商品存在严重质量问题，包括但不限于：护肤品过敏、食品变质、电子产品故障等。尽管投诉量巨大，但团队的处理态度消极，退换货流程复杂漫长。

消费者权益保护专家呼吁，直播带货行业亟需建立更严格的准入标准和监管机制，不能让"家人们""亲"等亲昵称呼掩盖商业本质。`,
    category: 'dujia-baoliao',
    tags: ['直播带货', '选品内幕', '高佣金', '消费者权益'],
    views: 189000,
    date: '2026-07-03',
    author: '独家调查组',
    image: 'https://readdy.ai/api/search-image?query=Inside%20a%20Chinese%20live%20streaming%20ecommerce%20studio%2C%20behind%20the%20scenes%20of%20product%20selection%2C%20boxes%20of%20products%20stacked%2C%20dim%20backstage%20lighting%2C%20investigative%20journalism%20style%2C%20warm%20studio%20lights%20in%20background%2C%20Chinese%20internet%20industry%20aesthetic%2C%20documentary%20photography&width=800&height=500&seq=article-hero-07&orientation=landscape',
    featured: false,
    exclusive: true,
    hot: false,
  },
  {
    id: 8,
    title: '某网络歌手被指抄袭，新歌旋律与国外小众歌曲高度相似',
    excerpt: '拥有千万粉丝的网络歌手近日发布新歌，被音乐博主指出副歌部分与一首2019年的国外小众歌曲旋律几乎完全一致，引发抄袭争议。',
    content: `拥有千万粉丝的网络歌手近日发布新歌《心动信号》，上线24小时内播放量突破5000万。然而，有专业音乐博主指出，该歌曲副歌部分与一首2019年的国外小众独立音乐人作品高度相似。

经过音频波形对比，两首歌曲在旋律走向、节奏型和和弦进行上确实存在大量重合，相似度超过80%。业内人士分析，这已超出"巧合"可以解释的范围。

该歌手工作室随后发布声明，称歌曲系原创，所谓"抄袭"是"恶意抹黑"，并表示将追究造谣者的法律责任。但声明中并未提供歌曲创作过程的具体证据。

音乐版权律师表示，歌曲抄袭的判定需要专业机构进行音轨对比鉴定。如果最终认定为抄袭，根据《著作权法》，侵权方需承担停止侵害、消除影响、赔礼道歉、赔偿损失等法律责任。

近年来，网络歌曲抄袭事件频发。有业内人士指出，部分网络歌手为了保持高频更新速度，往往在创作环节"偷工减料"，甚至直接从冷门作品中"借鉴"。`,
    category: 'mingxing-heiliao',
    tags: ['歌曲抄袭', '网络歌手', '版权争议', '音乐行业'],
    views: 234000,
    date: '2026-07-03',
    author: '音乐观察',
    image: 'https://readdy.ai/api/search-image?query=A%20music%20plagiarism%20controversy%20scene%2C%20Chinese%20internet%20singer%20in%20a%20recording%20studio%2C%20musical%20notes%20overlapping%20on%20a%20screen%2C%20dramatic%20lighting%2C%20music%20industry%20investigation%20theme%2C%20warm%20studio%20ambiance%2C%20professional%20photography%2C%20suspenseful%20mood&width=800&height=500&seq=article-hero-08&orientation=landscape',
    featured: false,
    exclusive: false,
    hot: false,
  },
  {
    id: 9,
    title: '突发：某短视频平台大V因涉嫌组织网络赌博被警方带走',
    excerpt: '拥有千万级粉丝的短视频大V今日下午被警方从工作室带走，据悉涉嫌利用直播间组织网络赌博活动，涉及金额巨大。',
    content: `拥有千万级粉丝的短视频大V今日下午被警方从工作室带走调查，现场画面在网络上迅速传播。

据知情人士透露，该大V涉嫌利用直播间的"抽奖""竞猜"等互动环节，变相组织网络赌博活动。其操作手法包括：要求粉丝通过"打赏"购买虚拟筹码参与竞猜，猜中者可以获得高额现金奖励，本质上构成了赌博行为。

警方初步调查显示，该赌博网络涉及多个直播平台和数十个关联账号，涉案金额可能高达数亿元。大量参与者在不知不觉中陷入赌博陷阱，有人因此倾家荡产。

该大V此前以"豪爽""仗义"人设走红，经常在视频中展示奢华生活。现在看来，这些炫富行为很可能是为吸引更多人参与赌博活动而精心设计的"诱饵"。

平台方已紧急下架该大V所有视频内容，并表示将全力配合警方调查。网络安全专家提醒广大网民，要警惕直播平台上的各类"抽奖""竞猜"活动，切勿因贪图小利而陷入违法陷阱。`,
    category: 'shehui-redian',
    tags: ['网络赌博', '大V被抓', '直播抽奖', '警方行动'],
    views: 623000,
    date: '2026-07-02',
    author: '吃瓜前线',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20short%20video%20influencer%20being%20arrested%20by%20police%2C%20police%20car%20outside%20a%20modern%20studio%20building%2C%20night%20scene%20with%20flashing%20lights%2C%20dramatic%20law%20enforcement%20action%2C%20Chinese%20news%20photography%20style%2C%20urgent%20atmosphere%2C%20red%20and%20blue%20police%20light%20reflections&width=800&height=500&seq=article-hero-09&orientation=landscape',
    featured: true,
    exclusive: true,
    hot: true,
  },
  {
    id: 10,
    title: '健身博主人设崩塌：私下饮食混乱，好身材全靠修图和打光',
    excerpt: '一位以"自律""健康"人设走红的健身博主被拍到私下频繁出入快餐店，其引以为傲的腹肌和身材被指主要靠修图软件和大片级打光实现。',
    content: `一位以"自律""健康"人设走红的健身博主被拍到私下频繁出入快餐店和高热量甜品店，其引以为傲的完美身材被指主要靠修图软件和大片级打光实现。

根据狗仔队持续两周的跟拍，该博主在工作日几乎每天都会光顾快餐店，点单内容包括炸鸡、汉堡、奶昔等高热量食品。更讽刺的是，就在被拍到吃炸鸡的当天傍晚，该博主发布了一条健身视频，标题为"自律的人从不放纵"。

随后，有摄影专业人士分析了该博主的照片和视频，发现其使用的修图软件至少进行了腰腹收紧、手臂塑形、光影重塑等多个步骤的后期处理。其拍摄现场的照片泄露显示，拍摄时使用了多盏专业影视灯从不同角度打光，以制造肌肉线条的阴影效果。

事件曝光后，该博主发布道歉声明，承认"在形象管理上存在过度包装"，但强调自己确实保持规律健身习惯，只是"不想让粉丝看到不完美的一面"。

健身行业从业者指出，近年来社交媒体上"身材焦虑"问题日益严重，部分健身博主通过造假手段营造不切实际的身材标准，对年轻人的心理健康造成负面影响。`,
    category: 'wanghong-tafang',
    tags: ['健身博主', '人设崩塌', '修图造假', '身材焦虑'],
    views: 178000,
    date: '2026-07-02',
    author: '真相调查',
    image: 'https://readdy.ai/api/search-image?query=Fitness%20blogger%20fake%20physique%20exposed%2C%20split%20scene%20showing%20perfect%20gym%20photo%20vs%20reality%20eating%20junk%20food%2C%20dramatic%20contrast%2C%20before%20and%20after%20concept%2C%20Chinese%20social%20media%20drama%2C%20warm%20gym%20lighting%20vs%20dark%20fast%20food%20restaurant%2C%20editorial%20photography&width=800&height=500&seq=article-hero-10&orientation=landscape',
    featured: false,
    exclusive: false,
    hot: false,
  },
  {
    id: 11,
    title: '知名情感博主被曝PUA学员，以情感咨询为名骗取女性信任',
    excerpt: '一位拥有200万粉丝的情感博主被多名女学员实名举报，指控其以情感咨询服务为名，实施精神控制和情感操控，部分受害者出现严重心理问题。',
    content: `一位拥有200万粉丝的情感博主被多名女学员实名举报，指控其以情感咨询服务为名，实施精神控制和情感操控。

举报材料显示，该博主通过短视频平台发布"情感干货"，吸引正处情感低谷期的女性关注。在获取信任后，以"一对一深度咨询"为名收取高额费用，单人收费从几千元到数万元不等。

而在所谓的"深度咨询"过程中，该博主并非提供专业的心理辅导，而是对学员进行精神打压和控制。他先是否定学员的自我价值，制造依赖感，然后逐步引导学员做出各种不合理的行为，包括与前男友断绝联系、辞去工作"重新开始"等。

多名受害者表示，在接受"咨询"后出现了严重的焦虑、抑郁症状，有些人甚至产生了轻生念头。但该博主对此不予理会，反而指责学员"不够配合""态度不端正"。

中国心理学会相关专家指出，情感咨询行业目前缺乏有效监管，大量不具备专业资质的人员打着"情感导师"旗号进行非法活动，严重危害公众心理健康。建议公众在选择情感咨询服务时，务必核实对方的专业资质。`,
    category: 'shehui-redian',
    tags: ['情感博主', 'PUA', '精神控制', '心理咨询'],
    views: 156000,
    date: '2026-07-01',
    author: '社会观察',
    image: 'https://readdy.ai/api/search-image?query=Emotional%20manipulation%20scandal%20scene%2C%20dark%20office%20with%20a%20figure%20in%20shadow%2C%20vulnerable%20person%20seeking%20help%2C%20psychological%20control%20theme%2C%20dramatic%20lighting%20with%20warm%20and%20cold%20contrast%2C%20Chinese%20investigative%20reporting%20style%2C%20suspenseful%20atmosphere%2C%20documentary%20photography&width=800&height=500&seq=article-hero-11&orientation=landscape',
    featured: false,
    exclusive: false,
    hot: false,
  },
  {
    id: 12,
    title: '震惊：某知名吃播被拍到催吐画面，暴饮暴食人设彻底崩塌',
    excerpt: '有网友在餐厅洗手间偶遇某知名"大胃王"吃播并拍下其催吐画面，视频在网络上迅速传播。该播主此前一直标榜自己"怎么吃都不胖"的超人体质。',
    content: `有网友在餐厅洗手间偶遇某知名"大胃王"吃播并拍下其催吐画面，视频在网络上迅速传播，引发轩然大波。

该吃播以"一顿吃十人份""怎么吃都不胖"的人设吸引了数百万粉丝。视频中，她经常在镜头前吃下大量高热量食物，并展示完全平坦的腹部，声称这是"天生体质"。

然而被曝光的偷拍画面显示，该播主在吃完直播内容后，会立即前往洗手间进行催吐。知情人士透露，这并非偶发事件，而是其每场直播后的"固定流程"。

医学专家指出，长期催吐会导致严重的健康问题，包括但不限于：电解质紊乱、心律失常、食道损伤、牙齿腐蚀、胃部疾病等。严重者甚至可能因电解质失衡导致心脏骤停。

事件发酵后，多家平台宣布将加强对"大胃王"类内容的审核，禁止展示过度饮食和浪费食物的行为。中国营养学会也呼吁公众理性看待"大胃王"文化，不要将暴饮暴食美化为"才艺"。

该播主目前已删除所有视频并关闭社交账号。据知情人士透露，其因长期催吐已出现严重健康问题，正在接受治疗。`,
    category: 'wanghong-tafang',
    tags: ['吃播', '催吐', '大胃王', '健康风险'],
    views: 398000,
    date: '2026-07-01',
    author: '健康关注',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mukbang%20streamer%20scandal%2C%20dramatic%20restaurant%20bathroom%20scene%2C%20dark%20atmosphere%20with%20harsh%20lighting%2C%20shocking%20revelation%20theme%2C%20contrast%20between%20food%20abundance%20and%20hidden%20struggle%2C%20editorial%20photography%2C%20Chinese%20internet%20drama%20aesthetic%2C%20raw%20documentary%20style&width=800&height=500&seq=article-hero-12&orientation=landscape',
    featured: false,
    exclusive: true,
    hot: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小明同学',
    role: '忠实读者',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20professional%20headshot%2C%20neutral%20expression%2C%20simple%20warm%20background%2C%20clean%20portrait%20photography%2C%20soft%20natural%20lighting%2C%20modern%20Asian%20professional%20style&width=120&height=120&seq=avatar-01&orientation=squarish',
    content: '自从关注了91吃瓜，我再也不怕错过任何网红塌房新闻了！更新速度超级快，比微博热搜还及时，每次都是第一时间看到最新爆料。',
    rating: 5,
  },
  {
    id: 2,
    name: '娱乐小达人',
    role: '资深吃瓜群众',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20friendly%20smile%2C%20warm%20studio%20lighting%2C%20simple%20neutral%20background%2C%20professional%20headshot%20style%2C%20natural%20expression%2C%20modern%20portrait%20photography&width=120&height=120&seq=avatar-02&orientation=squarish',
    content: '全网吃瓜就属这里最全最及时！很多独家黑料其他地方根本看不到，深度分析也很到位。每天刷一刷已经成为我的习惯了。',
    rating: 5,
  },
  {
    id: 3,
    name: '爆料前线',
    role: '热心网友',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20casual%20portrait%2C%20confident%20expression%2C%20warm%20lighting%2C%20urban%20style%2C%20modern%20portrait%20photography%2C%20simple%20background%2C%20natural%20pose&width=120&height=120&seq=avatar-03&orientation=squarish',
    content: '之前在这里看到一个博主的黑料，当时还不太信，结果过了两周就真的塌房了！这信息源也太准了吧，果断推荐给身边所有人。',
    rating: 5,
  },
  {
    id: 4,
    name: '八卦研究员',
    role: '深度用户',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20woman%20intellectual%20portrait%2C%20thoughtful%20expression%2C%20warm%20soft%20lighting%2C%20minimalist%20background%2C%20modern%20portrait%20photography%2C%20natural%20style%2C%20clean%20composition&width=120&height=120&seq=avatar-04&orientation=squarish',
    content: '不只是简单的爆料，文章质量很高，有深度有分析。每个塌房事件都整理得很清楚，时间线、证据链一目了然，专业吃瓜必备！',
    rating: 5,
  },
  {
    id: 5,
    name: '吃瓜小分队',
    role: '社群活跃用户',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20friendly%20smile%20portrait%2C%20casual%20style%2C%20warm%20lighting%2C%20simple%20background%2C%20modern%20portrait%20photography%2C%20approachable%20expression%2C%20clean%20composition&width=120&height=120&seq=avatar-05&orientation=squarish',
    content: '界面很清爽，没有乱七八糟的广告，浏览体验超棒！分类也很清晰，想看什么类型的黑料都能很快找到。',
    rating: 5,
  },
];

export const milestones = [
  { number: '50万+', label: '每日活跃用户' },
  { number: '10,000+', label: '累计独家爆料' },
  { number: '500万+', label: '月浏览量' },
  { number: '98%', label: '用户满意度' },
];